var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 113,
    viewBox: "0 0 113 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M75.9977 9H36.607C22.319 9 14 17.366 14 31.701V80.252C14 94.822 22.319 103 36.607 103H75.9977C90.516 103 98.6 94.822 98.6 80.252V31.701C98.6 17.366 90.516 9 75.9977 9Z",
    fill: "#8A92A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8996 30.8525C37.8866 30.8525 37.8761 30.8631 37.8761 30.876C37.8761 30.889 37.8655 30.8995 37.8525 30.8996C35.8377 30.9123 34.2101 32.5524 34.2101 34.5655C34.2101 36.5865 35.8504 38.2315 37.8761 38.2315H51.9246C53.9503 38.2315 55.5953 36.5865 55.5953 34.5138C55.5953 32.4975 53.9503 30.8525 51.9246 30.8525H37.8996ZM74.7243 59.4755H37.8761C35.8504 59.4755 34.2101 57.8305 34.2101 55.8095C34.2101 53.7885 35.8504 52.1388 37.8761 52.1388H74.7243C76.7453 52.1388 78.3903 53.7885 78.3903 55.8095C78.3903 57.8305 76.7453 59.4755 74.7243 59.4755ZM74.7243 80.9545H37.8761C36.4661 81.1425 35.1031 80.4375 34.3511 79.2625C33.5991 78.0405 33.5991 76.4895 34.3511 75.3145C35.1031 74.0925 36.4661 73.4345 37.8761 73.5755H74.7243C76.5996 73.7635 78.0143 75.3615 78.0143 77.2885C78.0143 79.1638 76.5996 80.7665 74.7243 80.9545Z",
    fill: "#8A92A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8924 25.8646C76.8838 24.5371 78.7637 24.2646 80.0912 25.256C81.4187 26.2474 81.6912 28.1273 80.6997 29.4548L36.4207 88.7454C35.4293 90.0729 33.5495 90.3453 32.222 89.3539C30.8945 88.3625 30.622 86.4827 31.6134 85.1552L75.8924 25.8646Z",
    fill: "#ED7E82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCase);
export default __webpack_public_path__ + "static/media/emptyCase.64ea6c6ed028548c0fe5592c2b3ecf0c.svg";
export { ForwardRef as ReactComponent };